import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import { showErrorMessage } from "../../../redux-saga/redux/toast";
import {
  getExtraMarketsFailure,
  getExtraMarketsStart,
  getExtraMarketsSuccess,
  getSingleMatchDetailsFailure,
  getSingleMatchDetailsStart,
  getSingleMatchDetailsSuccess
} from "../../redux/extraMarkets";
import ExtraMarketsService from "../../services/extraMarkets";

function* extraMarkets() {
  yield takeEvery(getSingleMatchDetailsStart.type, singleMatchWorker);
  yield takeLatest(getExtraMarketsStart.type, extraMarketsWorker);
}
function* extraMarketsWorker(action) {
  try {
    const { data, error } = yield call(
      ExtraMarketsService.getExtraMarkets,
      action.payload
    );
    if (data) {
      yield put(
        getExtraMarketsSuccess({ matchMarkets: data, ...action?.payload })
      );
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getExtraMarketsFailure());
    }
  } catch (error) {
    yield put(getExtraMarketsFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}
function* singleMatchWorker(action) {
  try {
    const { data, error } = yield call(
      ExtraMarketsService.getSingleMatch,
      action.payload
    );
    if (data) {
      yield put(getSingleMatchDetailsSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getSingleMatchDetailsFailure());
    }
  } catch (error) {
    yield put(getSingleMatchDetailsFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}

export default extraMarkets;
